import React from 'react';
import './LongTermScheduleCalendar.scss';
import { Alert } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

export default class LtsCloneWarning extends React.Component {
    render() {
        const { loading, longTermSchedule } = this.props;

        if (loading || !longTermSchedule || !longTermSchedule.isClone) {
            return null;
        }

        return (
            <Alert color="info" fade={false}>
                <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />
                This is a copy of a previous schedule - please make sure all
                values are updated appropriately before saving.
            </Alert>
        );
    }
}
